<template>
  <div>
    <div class="cover-table">
      <Table
        border
        style="width: 100%;"
        :loading="loading"
        :columns="tableColumns"
        :data="tableData"
        highlight-row
      >
      </Table>
    </div>
  </div>
</template>
<style scoped></style>
<script>
import tableTwoMixin from "@/components/tableTwoMixin";

export default {
  mixins: [tableTwoMixin],
  data() {
    return {
      tableColumns: [
        {
          title: "序号",
          type: "index",
          width: 70,
          fixed: "left",
          align: "center",
        },
        { title: "项目编号", key: "projectNo", minWidth: 210, tooltip: true },
        { title: "班组编号", key: "teamNo", minWidth: 180, tooltip: true },
        { title: "证件类型", key: "idCardType", minWidth: 180, tooltip: true },
        // { title: "字典表", key: "areaName", minWidth: 140, tooltip: true },
        {
          title: "证件号码",
          key: "idCardNumber",
          minWidth: 180,
          tooltip: true,
        },
        {
          title: "进退场日期",
          key: "date",
          minWidth: 210,
          tooltip: true,
        },
        { title: "类型", key: "type", minWidth: 210, tooltip: true },
        {
          title: "凭证扫描件",
          key: "voucher",
          minWidth: 210,
          tooltip: true,
        },
        // { title: '参建班组', key: 'teamName', minWidth: 210, tooltip: true },
        {
          title: "数据来源",
          key: "sourceAreaCode",
          // align: "right",
          minWidth: 100,
        },
        // { title: '法定代表人职称', key: 'workDate', minWidth: 120 },
        // { title: '法定代表人证件类型', key: 'attendanceNum', align:'right', minWidth:100 },
        // { title: '法定代表人证件号码', key: 'attendanceRate', align:'right', minWidth: 100 },
        // { title: '注册资本（万元）',   align: 'center', minWidth:100 },
        // { title: '实收资本(万元)',  align: 'center', minWidth:100 },
        // { title: '注册资本币种',   align: 'center', minWidth:100 },
        // { title: '注册日期', align: 'center', minWidth:100 },
        // { title: '成立日期',  align: 'center', minWidth:100 },
        // { title: '办公电话',  align: 'center', minWidth:100 },
        // { title: '传真号码', align: 'center', minWidth:100 },
        // { title: '联系人姓名',  align: 'center', minWidth:100 },
        // { title: '联系人办公电话',  align: 'center', minWidth:100 },
        // { title: '企业联系邮箱',  align: 'center', minWidth:100 },
        // { title: '企业网址',  align: 'center', minWidth:100 },
        // { title: '企业备注',  align: 'center', minWidth:100 },
        // { title: '数据来源', align: 'center', minWidth:100 },
      ],
    };
  },
};
</script>
